const defaults = {
  meta: {
    requiresAuth: false,
    forceLoadTranslationsFromBackend: true
  }
}

const publicRoutes = [
  {
    path: "/sign-up/:location?",
    name: "sign-up",
    component: () => import("../views/SignUpView.vue"),
    meta: defaults.meta
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
    meta: defaults.meta
  },
  {
    path: "/sso/auth/callback",
    name: "sso-callback",
    component: () => import("../views/SingleSignOnCallbackView.vue")
  },
  {
    path: "/sso/:accountId",
    name: "sso",
    component: () => import("../views/SingleSignOnLoginView.vue"),
    meta: defaults.meta
  },
  {
    path: "/password",
    name: "password",
    redirect: () => ({ name: "reset-password" }),
    children: [
      {
        path: "reset",
        name: "reset-password",
        component: () => import("../views/ResetPassword/ResetPasswordView.vue"),
        meta: defaults.meta
      },
      {
        path: "recover/:userUuid/:token",
        name: "recover-password-form",
        component: () => import("../views/ResetPassword/ResetPasswordFormView.vue"),
        meta: defaults.meta
      },
      {
        path: "recovered",
        name: "password-recovered",
        component: () => import("../views/ResetPassword/ResetPasswordSuccessView..vue"),
        meta: defaults.meta
      }
    ]
  }
]

export default publicRoutes
